var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.667 14.545c.401.122.944.122 1.866.122h6.934c.922 0 1.464 0 1.866-.122m-10.666 0a1.46 1.46 0 0 1-.242-.096 2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.533c0-1.12 0-1.68.218-2.107a2 2 0 0 1 .874-.875c.428-.218.988-.218 2.108-.218h6.934c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.875c.218.427.218.987.218 2.107v6.934c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874 1.46 1.46 0 0 1-.242.096m-10.666 0c0-.54.003-.825.05-1.065a2.667 2.667 0 0 1 2.096-2.095c.258-.051.567-.051 1.187-.051h4c.62 0 .93 0 1.187.05a2.667 2.667 0 0 1 2.095 2.096c.048.24.051.526.051 1.065m-2.666-8.212a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquareIcon);
export default __webpack_public_path__ + "static/media/user-square-icon.9f5eb9e7e453088f385e5fa1d15b4bbe.svg";
export { ForwardRef as ReactComponent };